import { Link } from "react-router-dom";

export const MobileCta = () => (
  <div
    className="fixed inset-x-0 bottom-0 z-40 border-t border-navy/15 bg-navy/10 backdrop-blur-md md:hidden"
    data-testid="mobile-sticky-cta"
  >
    <Link
      to="/contact"
      data-testid="sticky-contact-button"
      className="flex items-center justify-center bg-gold py-4 text-[13px] font-bold tracking-wide text-navy-dark active:bg-gold-light"
    >
      Get in Touch
    </Link>
  </div>
);
